// =============================================
// API Configuration for MediCureOn
// Backend and external service endpoints
// =============================================

export const apiConfig = {
  // Azure Function App URL
  backendUrl: "https://medicureon-app-api.azurewebsites.net",
  
  // Your Function Keys
  functionKeys: {
    health: "or0Gx2cWyzvGCv-2A8aq6dtNELF5c3d-_DsCkUJ1aLNSAzFuGfFmiQ==",
    profileGet: "QXR1Kn-EvcrrbrvHIgCUPWFFHNALcvmMQXKxF1XHsi18AzFuUafBRw==",
    profileUpdate: "GHqPIhBN1foEaEes--LIMAS8veji9TYMHI28XTW6Kpr8AzFuG7GZNw==",
    profilePicture: "8G52jO7IxbnQSwyRE_w6Bs8QWWEzTqGnKxjLP6kHDesCAzFujq9JHA==",
    createCheckoutSession: "nNtAsgHBWDH1bg-bsOFfoJFd4iUBLq16gbLfkF6V8o3pAzFuX9jpQw==",
    checkSubscriptionStatus: "eHh14ElI14vzccqjOtaeFJrw1VCjf5IXtYXBu5zoEOEuAzFu77_lmw==",
    saveSubscription: "s3_ECo4iyQcMFDU1v6w6ue73c7bUYn-EIMRNze0kACfZAzFuFi352A==",
    enrollInPlan: "H8NKGodW2BKUw5r9WXatmGLybOrkIyi_wW9TIvU-YpfRAzFuajKk-A==",
    retrieveCheckoutSession: "Z6dPkafK833f4UUpBAdOGs8rQfui1HOWC9GBdfs5i7k4AzFuZDbJ6w==",
    unenrollFromPlan: "FNuK90uYL0C_66Jt8brFbDKZsTRnDr0w_LVkxUImq-NIAzFuldpteA==",
    iomtDataSave: "4JTTDVg3nbWJzJwQWuXSeB3V_G8hyXL3Vs47MZjb0BqXAzFuvDGFBQ==",
    iomtDataGet: "y1iSLPBYfza3MxF2idY4Ev_eOfqvnWYDL3E_Z3OYFveHAzFuaf1thA==",
    getActivePlans: "QXR1Kn-EvcrrbrvHIgCUPWFFHNALcvmMQXKxF1XHsi18AzFuUafBRw==",
    
    // Rewards & Gamification System Function Keys
    mediPointsManager: "u3_y0hLx4lRCdC3iYuUqoUUz7rPRgjFdb7lpDqEVbmu3AzFu8CITEA==",
    challengesManager: "Hb8fNY987YuV6MQsq-ixrkWYxhRGKyV3DUrIBfRQcXTsAzFuI9xg7A==",
    challengesProgressTracker: "YwgenBaNXgmkhBczrsK_tP3Fk0d5nTRj63ZILb2k8qGNAzFurrWD0g==",
    communityTitlesManager: "FHGVWOHhzFGyW_b8yJ_Fu10_d_VUJVNRUnPNAW2TO23IAzFuBZV2Aw==",
    leaderboardManager: "0zLE4QoYRWBzOtpE8l7WoG1JNx3msqJppRInWvGmEdP7AzFu6k98Sg==",
    challengeCompletionHandler: "kb1njHR0N3ICHg4QswMSPnrPMDg3KPkPiMvx8xB5yqdFAzFuko9XTA==",
    achievementsManager: "kb1njHR0N3ICHg4QswMSPnrPMDg3KPkPiMvx8xB5yqdFAzFuko9XTA==",
    dailyOpportunitiesManager: "u3_y0hLx4lRCdC3iYuUqoUUz7rPRgjFdb7lpDqEVbmu3AzFu8CITEA==",
    
    // Production Challenge System Function Keys
    challenges: "Hb8fNY987YuV6MQsq-ixrkWYxhRGKyV3DUrIBfRQcXTsAzFuI9xg7A==",
    
    // Feedback System Function Keys
    feedbackSubmit: "2o4yEMXQVV7g8d6Lu0b5PtoiKjpKxBk2cmVMbKst5qhvAzFuKNjQjg==",
    feedbackAdmin: "ZAKyoXpYb-OsaQAI2I8j_6sRlSABMccSyYV5_KJAG9sAAzFuUIFt4w=="
  },
  
  // Endpoints matching your Azure Functions
  endpoints: {
    // Health check
    health: "/api/health",
    
    // Profile endpoints
    profile: "/api/profile",
    profiles: {
      get: (userId) => `/api/profiles/${userId}`,
      update: (userId) => `/api/profiles/${userId}`,
      picture: (userId) => `/api/profiles/${userId}/picture`,
      activePlans: (userId) => `/api/profiles/${userId}/active-plans`,
      data: (userId, dataType) => `/api/profiles/${userId}/data/${dataType}`
    },
    
    // IoMT data endpoints
    iomt: {
      save: (userId) => `/api/iomt-data-save/${userId}`,
      get: (userId) => `/api/iomt-data-get/${userId}`
    },
    
    // Subscription endpoints
    subscription: {
      check: (userId) => `/api/subscriptions/${userId}`,
      save: "/api/save-subscription",
      enrollPlan: "/api/enroll-in-plan",
      unenrollPlan: (userId, planId) => `/api/plans/${userId}/${planId}`,
      activePlans: (userId) => `/api/subscription/${userId}/active-plans`
    },
    
    // Payment endpoints
    payments: {
      createCheckout: "/api/create-checkout-session",
      webhook: "/api/stripe-webhook",
      retrieveSession: "/api/retrieve-checkout-session"
    },
    
    // Rewards & Gamification System Endpoints
    rewards: {
      // Points Management
      points: {
        balance: "/api/medi-points-manager",
        add: "/api/medi-points-manager",
        deduct: "/api/medi-points-manager",
        history: "/api/medi-points-manager"
      },
      
      // Challenges Management
      challenges: {
        // New production endpoints for challenge management
        manage: "/api/challenges-manager",
        list: "/api/challenges-manager", 
        templates: "/api/challenges-manager",
        progress: "/api/challenges-progress-tracker",
        completion: "/api/challenge-completion-handler",
        
        // Legacy endpoints (keeping for compatibility)
        join: "/api/challenges-manager",
        updateProgress: "/api/challenges-manager",
        getStatus: "/api/challenges-manager",
        leave: "/api/challenges-manager",
        
        // Progress Tracking
        trackDaily: "/api/challenges-progress-tracker",
        getProgress: "/api/challenges-progress-tracker",
        manualCheck: "/api/challenges-progress-tracker",
        
        // Completion Handling
        checkCompletion: "/api/challenge-completion-handler",
        verifyCompletion: "/api/challenge-completion-handler",
        getCompleted: "/api/challenge-completion-handler",
        getStats: "/api/challenge-completion-handler",
        abandon: "/api/challenge-completion-handler"
      },
      
      // Community Titles
      community: {
        evaluate: "/api/community-titles-manager",
        updateStats: "/api/community-titles-manager",
        getStatus: "/api/community-titles-manager",
        getLeaders: "/api/community-titles-manager"
      },
      
      // Leaderboards
      leaderboard: {
        update: "/api/leaderboard-manager",
        getTop: "/api/leaderboard-manager",
        getUserRank: "/api/leaderboard-manager",
        getNearby: "/api/leaderboard-manager",
        getCountryRankings: "/api/leaderboard-manager",
        getCommunityLeaders: "/api/leaderboard-manager",
        refreshCache: "/api/leaderboard-manager"
      },
      
      // Achievements Management
      achievements: {
        getUserAchievements: "/api/achievements-manager",
        getUnlocked: "/api/achievements-manager",
        checkProgress: "/api/achievements-manager",
        unlock: "/api/achievements-manager",
        getAll: "/api/achievements-manager",
        getCategories: "/api/achievements-manager"
      },
      
      // Daily Opportunities
      dailyOpportunities: {
        getAvailable: "/api/daily-opportunities-manager",
        complete: "/api/daily-opportunities-manager",
        getUserProgress: "/api/daily-opportunities-manager",
        getRewards: "/api/daily-opportunities-manager"
      }
    },
    
    // Future endpoints
    healthData: "/api/health-data",
    crypto: "/api/crypto-payments",
    aiCoach: "/api/ai-coach",
    
    // Feedback Management System
    feedback: {
      submit: "/api/feedback/submit",
      admin: {
        list: "/api/feedback-admin",
        detail: (id) => `/api/feedback-admin?action=${id}`,
        update: (id) => `/api/feedback-admin?action=${id}`,
        response: (id) => `/api/feedback-admin?action=${id}&type=response`,
        analytics: "/api/feedback-admin?action=analytics",
        bulk: "/api/feedback-admin?action=bulk"
      }
    }
  },

  // Production Challenge System Endpoints - Azure Data Lake Integration
  challenges: {
    // User Challenge Data from Azure Data Lake
    getUserActiveChallenges: `https://medicureon-app-api.azurewebsites.net/api/challenges-manager`,
    getUserCompletedChallenges: `https://medicureon-app-api.azurewebsites.net/api/challenge-completion-handler`,
    getUserChallengeProgress: `https://medicureon-app-api.azurewebsites.net/api/challenges-progress-tracker`,
    
    // Challenge Operations
    joinChallenge: `https://medicureon-app-api.azurewebsites.net/api/challenges-manager`,
    updateChallengeStatus: `https://medicureon-app-api.azurewebsites.net/api/challenges-manager`,
    validateProgress: `https://medicureon-app-api.azurewebsites.net/api/challenges-progress-tracker`,
    
    // Challenge Lifecycle
    getAvailable: `https://medicureon-app-api.azurewebsites.net/api/challenges-manager`,
    startChallenge: `https://medicureon-app-api.azurewebsites.net/api/challenges-manager`,
    pauseChallenge: `https://medicureon-app-api.azurewebsites.net/api/challenges-manager`,
    resumeChallenge: `https://medicureon-app-api.azurewebsites.net/api/challenges-manager`,
    stopChallenge: `https://medicureon-app-api.azurewebsites.net/api/challenges-manager`,
    cancelChallenge: `https://medicureon-app-api.azurewebsites.net/api/challenges-manager`
  }
};

// Enhanced Helper functions for Rewards API calls
export const rewardsAPI = {
  // Points Management
  getBalance: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.points.balance}?code=${apiConfig.functionKeys.mediPointsManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'balance',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching balance:', error);
      return { success: false, error: error.message };
    }
  },
  
  addPoints: async (userId, points, reason, metadata, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.points.add}?code=${apiConfig.functionKeys.mediPointsManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'add',
            userId: userId,
            points: points,
            reason: reason,
            metadata: metadata || {}
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error adding points:', error);
      return { success: false, error: error.message };
    }
  },

  deductPoints: async (userId, points, reason, metadata, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.points.deduct}?code=${apiConfig.functionKeys.mediPointsManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'deduct',
            userId: userId,
            points: points,
            reason: reason,
            metadata: metadata || {}
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error deducting points:', error);
      return { success: false, error: error.message };
    }
  },

  getPointsHistory: async (userId, token, limit = 50, offset = 0) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.points.history}?code=${apiConfig.functionKeys.mediPointsManager}&limit=${limit}&offset=${offset}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'history',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching points history:', error);
      return { success: false, error: error.message };
    }
  },
  
  // Challenges Management
  joinChallenge: async (userId, challengeId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.join}?code=${apiConfig.functionKeys.challengesManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'join',
            userId: userId,
            challengeId: challengeId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error joining challenge:', error);
      return { success: false, error: error.message };
    }
  },

  updateChallengeProgress: async (userId, challengeId, metadata, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.updateProgress}?code=${apiConfig.functionKeys.challengesManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'update-progress',
            userId: userId,
            challengeId: challengeId,
            metadata: metadata
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error updating challenge progress:', error);
      return { success: false, error: error.message };
    }
  },

  getChallengeStatus: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.getStatus}?code=${apiConfig.functionKeys.challengesManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-status',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error getting challenge status:', error);
      return { success: false, error: error.message };
    }
  },

  leaveChallenge: async (userId, challengeId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.leave}?code=${apiConfig.functionKeys.challengesManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'leave',
            userId: userId,
            challengeId: challengeId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error leaving challenge:', error);
      return { success: false, error: error.message };
    }
  },

  getCompletedChallenges: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.getCompleted}?code=${apiConfig.functionKeys.challengeCompletionHandler}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-completed',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error getting completed challenges:', error);
      return { success: false, error: error.message };
    }
  },

  getChallengeStats: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.getStats}?code=${apiConfig.functionKeys.challengeCompletionHandler}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-stats',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error getting challenge stats:', error);
      return { success: false, error: error.message };
    }
  },

  checkChallengeCompletion: async (userId, challengeId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.checkCompletion}?code=${apiConfig.functionKeys.challengeCompletionHandler}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'check-completion',
            userId: userId,
            challengeId: challengeId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error checking challenge completion:', error);
      return { success: false, error: error.message };
    }
  },

  verifyChallengeCompletion: async (userId, challengeId, verification, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.verifyCompletion}?code=${apiConfig.functionKeys.challengeCompletionHandler}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'verify-completion',
            userId: userId,
            challengeId: challengeId,
            verification: verification
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error verifying challenge completion:', error);
      return { success: false, error: error.message };
    }
  },

  abandonChallenge: async (userId, challengeId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.abandon}?code=${apiConfig.functionKeys.challengeCompletionHandler}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'abandon',
            userId: userId,
            challengeId: challengeId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error abandoning challenge:', error);
      return { success: false, error: error.message };
    }
  },
  
  trackDailyProgress: async (userId, progressData, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.trackDaily}?code=${apiConfig.functionKeys.challengesProgressTracker}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'track-daily',
            userId: userId,
            progressData: progressData
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error tracking daily progress:', error);
      return { success: false, error: error.message };
    }
  },

  getChallengeProgress: async (userId, challengeId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.getProgress}?code=${apiConfig.functionKeys.challengesProgressTracker}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-progress',
            userId: userId,
            challengeId: challengeId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error getting challenge progress:', error);
      return { success: false, error: error.message };
    }
  },

  manualProgressCheck: async (userId, challengeId, metadata, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.manualCheck}?code=${apiConfig.functionKeys.challengesProgressTracker}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'manual-check',
            userId: userId,
            challengeId: challengeId,
            metadata: metadata
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error with manual progress check:', error);
      return { success: false, error: error.message };
    }
  },
  
  // Leaderboards
  getGlobalTop25: async (token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.leaderboard.getTop}?code=${apiConfig.functionKeys.leaderboardManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-top',
            type: 'global',
            limit: 25
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching global top 25:', error);
      return { success: false, error: error.message };
    }
  },

  getUserRank: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.leaderboard.getUserRank}?code=${apiConfig.functionKeys.leaderboardManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-user-rank',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching user rank:', error);
      return { success: false, error: error.message };
    }
  },

  getCountryRankings: async (token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.leaderboard.getCountryRankings}?code=${apiConfig.functionKeys.leaderboardManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-country-rankings'
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching country rankings:', error);
      return { success: false, error: error.message };
    }
  },

  getNearbyUsers: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.leaderboard.getNearby}?code=${apiConfig.functionKeys.leaderboardManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-nearby',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching nearby users:', error);
      return { success: false, error: error.message };
    }
  },

  updateLeaderboard: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.leaderboard.update}?code=${apiConfig.functionKeys.leaderboardManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'update',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error updating leaderboard:', error);
      return { success: false, error: error.message };
    }
  },
  
  // Community Titles
  evaluateForTitle: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.community.evaluate}?code=${apiConfig.functionKeys.communityTitlesManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'evaluate',
            userId: userId,
            forceCheck: false
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error evaluating for title:', error);
      return { success: false, error: error.message };
    }
  },

  updateCommunityStats: async (userId, statType, value, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.community.updateStats}?code=${apiConfig.functionKeys.communityTitlesManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'update-stats',
            userId: userId,
            statType: statType,
            value: value
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error updating community stats:', error);
      return { success: false, error: error.message };
    }
  },

  getCommunityStatus: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.community.getStatus}?code=${apiConfig.functionKeys.communityTitlesManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-status',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error getting community status:', error);
      return { success: false, error: error.message };
    }
  },

  getCommunityLeaders: async (token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.community.getLeaders}?code=${apiConfig.functionKeys.communityTitlesManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-leaders'
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error getting community leaders:', error);
      return { success: false, error: error.message };
    }
  },

  // Missing functions for OverviewTab
  getPointsBalance: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.points.balance}?code=${apiConfig.functionKeys.mediPointsManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'balance',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching points balance:', error);
      return { success: false, error: error.message, data: 0 };
    }
  },

  getUserChallenges: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.challenges.getStatus}?code=${apiConfig.functionKeys.challengesManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-status',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching user challenges:', error);
      return { success: false, error: error.message, data: { active: [], completed: [], failed: [] } };
    }
  },

  getUserLeaderboardPosition: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.leaderboard.getUserRank}?code=${apiConfig.functionKeys.leaderboardManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-position',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching leaderboard position:', error);
      return { success: false, error: error.message, data: { position: 0, score: 0 } };
    }
  },

  getUserAchievements: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.achievements.getUserAchievements}?code=${apiConfig.functionKeys.challengeCompletionHandler}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-achievements',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching user achievements:', error);
      return { success: false, error: error.message, data: [] };
    }
  },

  getDailyOpportunities: async (userId, token) => {
    try {
      const response = await fetch(
        `${apiConfig.backendUrl}${apiConfig.endpoints.rewards.dailyOpportunities.getAvailable}?code=${apiConfig.functionKeys.dailyOpportunitiesManager}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            action: 'get-daily-opportunities',
            userId: userId
          })
        }
      );
      return response.json();
    } catch (error) {
      console.error('Error fetching daily opportunities:', error);
      return { success: false, error: error.message, data: [] };
    }
  }
};

// Complete Country to Region Mapping - All 195 countries
export const countryToRegion = {
  // US Region (Americas, Africa, Middle East + default) - 115 countries
  "United States": "US",
  "Canada": "US",
  "Mexico": "US",
  "Guatemala": "US",
  "Belize": "US",
  "El Salvador": "US",
  "Honduras": "US",
  "Nicaragua": "US",
  "Costa Rica": "US",
  "Panama": "US",
  "Cuba": "US",
  "Jamaica": "US",
  "Haiti": "US",
  "Dominican Republic": "US",
  "Puerto Rico": "US",
  "Trinidad and Tobago": "US",
  "Barbados": "US",
  "Saint Lucia": "US",
  "Saint Vincent and the Grenadines": "US",
  "Grenada": "US",
  "Antigua and Barbuda": "US",
  "Dominica": "US",
  "Saint Kitts and Nevis": "US",
  "Bahamas": "US",
  "Brazil": "US",
  "Argentina": "US",
  "Chile": "US",
  "Uruguay": "US",
  "Paraguay": "US",
  "Bolivia": "US",
  "Peru": "US",
  "Ecuador": "US",
  "Colombia": "US",
  "Venezuela": "US",
  "Guyana": "US",
  "Suriname": "US",
  "French Guiana": "US",
  
  // African countries
  "Egypt": "US",
  "Libya": "US",
  "Tunisia": "US",
  "Algeria": "US",
  "Morocco": "US",
  "Sudan": "US",
  "South Sudan": "US",
  "Ethiopia": "US",
  "Eritrea": "US",
  "Djibouti": "US",
  "Somalia": "US",
  "Kenya": "US",
  "Uganda": "US",
  "Tanzania": "US",
  "Rwanda": "US",
  "Burundi": "US",
  "Democratic Republic of Congo": "US",
  "Republic of Congo": "US",
  "Central African Republic": "US",
  "Cameroon": "US",
  "Chad": "US",
  "Niger": "US",
  "Nigeria": "US",
  "Benin": "US",
  "Togo": "US",
  "Ghana": "US",
  "Burkina Faso": "US",
  "Mali": "US",
  "Senegal": "US",
  "Mauritania": "US",
  "Gambia": "US",
  "Guinea-Bissau": "US",
  "Guinea": "US",
  "Sierra Leone": "US",
  "Liberia": "US",
  "Ivory Coast": "US",
  "Cape Verde": "US",
  "São Tomé and Príncipe": "US",
  "Equatorial Guinea": "US",
  "Gabon": "US",
  "Angola": "US",
  "Zambia": "US",
  "Malawi": "US",
  "Mozambique": "US",
  "Zimbabwe": "US",
  "Botswana": "US",
  "Namibia": "US",
  "South Africa": "US",
  "Lesotho": "US",
  "Eswatini": "US",
  "Madagascar": "US",
  "Mauritius": "US",
  "Seychelles": "US",
  "Comoros": "US",
  
  // Middle East
  "Saudi Arabia": "US",
  "Yemen": "US",
  "Oman": "US",
  "United Arab Emirates": "US",
  "Qatar": "US",
  "Bahrain": "US",
  "Kuwait": "US",
  "Iraq": "US",
  "Syria": "US",
  "Lebanon": "US",
  "Jordan": "US",
  "Israel": "US",
  "Palestine": "US",
  "Iran": "US",
  "Turkey": "US",
  "Georgia": "US",
  "Armenia": "US",
  "Azerbaijan": "US",
  
  // EU Region (Europe - GDPR compliance) - 44 countries
  "Austria": "EU",
  "Belgium": "EU",
  "Bulgaria": "EU",
  "Croatia": "EU",
  "Cyprus": "EU",
  "Czech Republic": "EU",
  "Denmark": "EU",
  "Estonia": "EU",
  "Finland": "EU",
  "France": "EU",
  "Germany": "EU",
  "Greece": "EU",
  "Hungary": "EU",
  "Ireland": "EU",
  "Italy": "EU",
  "Latvia": "EU",
  "Lithuania": "EU",
  "Luxembourg": "EU",
  "Malta": "EU",
  "Netherlands": "EU",
  "Poland": "EU",
  "Portugal": "EU",
  "Romania": "EU",
  "Slovakia": "EU",
  "Slovenia": "EU",
  "Spain": "EU",
  "Sweden": "EU",
  "United Kingdom": "EU",
  "Norway": "EU",
  "Switzerland": "EU",
  "Iceland": "EU",
  "Liechtenstein": "EU",
  "Monaco": "EU",
  "San Marino": "EU",
  "Vatican City": "EU",
  "Andorra": "EU",
  "Serbia": "EU",
  "Montenegro": "EU",
  "North Macedonia": "EU",
  "Albania": "EU",
  "Bosnia and Herzegovina": "EU",
  "Kosovo": "EU",
  "Moldova": "EU",
  "Ukraine": "EU",
  "Belarus": "EU",
  "Russia": "EU",
  
  // APAC Region (Asia-Pacific) - 36 countries
  "Afghanistan": "APAC",
  "Pakistan": "APAC",
  "India": "APAC",
  "Bangladesh": "APAC",
  "Sri Lanka": "APAC",
  "Nepal": "APAC",
  "Bhutan": "APAC",
  "Maldives": "APAC",
  "Myanmar": "APAC",
  "Thailand": "APAC",
  "Laos": "APAC",
  "Cambodia": "APAC",
  "Vietnam": "APAC",
  "Malaysia": "APAC",
  "Singapore": "APAC",
  "Indonesia": "APAC",
  "Philippines": "APAC",
  "Brunei": "APAC",
  "East Timor": "APAC",
  "China": "APAC",
  "Mongolia": "APAC",
  "North Korea": "APAC",
  "South Korea": "APAC",
  "Japan": "APAC",
  "Taiwan": "APAC",
  "Hong Kong": "APAC",
  "Macau": "APAC",
  "Australia": "APAC",
  "New Zealand": "APAC",
  "Fiji": "APAC",
  "Papua New Guinea": "APAC",
  "Solomon Islands": "APAC",
  "Vanuatu": "APAC",
  "Samoa": "APAC",
  "Tonga": "APAC",
  "Tuvalu": "APAC",
  "Kiribati": "APAC",
  "Nauru": "APAC",
  "Palau": "APAC",
  "Marshall Islands": "APAC",
  "Micronesia": "APAC",
  
  // Central Asian countries (could go to APAC or US, defaulting to US)
  "Kazakhstan": "US",
  "Uzbekistan": "US",
  "Kyrgyzstan": "US",
  "Tajikistan": "US",
  "Turkmenistan": "US"
};

// Helper function to get region from country
export const getRegionFromCountry = (country) => {
  return countryToRegion[country] || "US";
};